import React, {Fragment, useRef, useState} from 'react';
import {useTheme} from "@material-ui/core";
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import { Field} from 'react-final-form';
import {Select, Accordion, Explanation_text, MultipleSelect, Text} from '../../';


export default function DealDetailsSection(props){
  const theme=useTheme();


  let contact_list=[];
  if(props.company!=undefined){for(let x of props.company.contacts){
    if(x.pivot.active_at_company==true){
      let contact={id:x.id};
      if(x.first_name!=null){contact.name=x.first_name+' ';}
      if(x.last_name!=null){contact.name+=x.last_name;}
      if(contact.name==undefined){contact.name='No name';}
      contact_list.push(contact);
  }}}

  return(
    <Accordion
                      style={{width:'calc(100% + 40px)', marginLeft:'-20px'}}
                      open={(props.open_section=='details')?true:false}
                      onChange={()=>{props.setOpenSection((props.open_section=='details')?undefined:'details')}}
                      content={[
                        {
                          title: (
                            <Field name='contacts'>{(f)=><Typography style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'0px', marginBottom:'0px'}}><span style={{color:theme.palette.primary.main}}>{"Details: "}</span>{(props.open_section=='details')?null:<span style={{fontSize:'12px', maxWidth: '200px',overflow:'hidden'}}>{f.input.value.length+' contacts'}</span>}</Typography>}</Field>
                          ),
                          content: (
                            <Grid container style={{ marginTop: '-20px' }}>
                            <Grid item xs={12} style={{marginBottom:'20px', marginTop:'10px'}}><MultipleSelect title='Contacts' name='contacts' with_id size='small' field select_data={contact_list}/></Grid>
                            <Grid item xs={12}><Text title='Description' name='description' multiline rows={3}/></Grid>
                            </Grid>
                          ),
                        },
                      ]}
                    />)
}
